module.exports = __webpack_public_path__ + "img/library-3.6d255f79.png";